// Código de banco no padrão FEBRABAN (3 dígitos) — normaliza removendo
// zeros à esquerda, pra comparação não depender de como o código chegou
// formatado (ex.: '033' vs '33'). Usado por bancosHomologados.js e
// bancoLogos.js.
export default function normalizeCodigoBanco(codigo) {
  return String(codigo || '').replace(/^0+(?=\d)/, '');
}
